import React from "react";
import { Box, IconButton } from "@mui/material";
import { ViewHeadline } from "@mui/icons-material/index";
import GridViewIcon from "../Icons/GridViewIcon";
import PropTypes from "prop-types";

export default function DisplayOptionsButtons(props) {
  const { onDisplayChange, currentDisplayOption } = props;

  function handleDisplayChange(newDisplayOption) {
    if (onDisplayChange) {
      onDisplayChange(newDisplayOption);
    }
  }

  return (
    <Box display="flex" ml={-1.5}>
      <IconButton
        id="display-grid-view"
        onClick={() => handleDisplayChange("grid")}
        color={currentDisplayOption === "grid" ? "primary" : "default"}
        size="large"
      >
        <GridViewIcon />
      </IconButton>
      <IconButton
        id="display-list-view"
        onClick={() => handleDisplayChange("list")}
        color={currentDisplayOption === "grid" ? "default" : "primary"}
        size="large"
      >
        <ViewHeadline />
      </IconButton>
    </Box>
  );
}

DisplayOptionsButtons.propTypes = {
  currentDisplayOption: PropTypes.oneOf(["grid", "list"]),
  onDisplayChange: PropTypes.func
};

DisplayOptionsButtons.defaultProps = {
  currentDisplayOption: "grid"
};
